module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.i.type == 'String') ? [_c('el-input', {
    ref: "input",
    attrs: {
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": _vm.i.placeholder
    },
    on: {
      "input": function(v) {
        if (_vm.i.OnInput) {
          _vm.i.OnInput(v)
        }
      },
      "blur": function(v) {
        if (_vm.i.OnBlur) {
          _vm.i.OnBlur(v)
        }
      },
      "change": function(v) {
        if (_vm.i.OnChange) {
          _vm.i.OnChange(v)
        }
      }
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, [(_vm.i.SuffixText) ? _c('i', {
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v(_vm._s(_vm.i.SuffixText))]) : _vm._e(), _vm._v(" "), (_vm.i.PrependText) ? _c('i', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.i.PrependText))]) : _vm._e(), _vm._v(" "), (_vm.i.AppendText) ? _c('i', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.i.AppendText))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Autocomplete') ? [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": _vm.i.placeholder
    },
    on: {
      "change": function(v) {
        if (_vm.i.OnChange) {
          _vm.i.OnChange(v)
        }
      }
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Label') ? [_vm._v("\n     " + _vm._s(_vm.getDataForPath(_vm.entity, _vm.i.field)) + "\n    "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'BooleanLabel') ? [_vm._v("\n     " + _vm._s(_vm._f("toSelect")(_vm.getDataForPath(_vm.entity, _vm.i.field), _vm.i.forSelectStoreName)) + "\n    "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Rate') ? [_c('el-rate', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "allow-half": "",
      "show-score": ""
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Password') ? [_c('el-input', {
    attrs: {
      "type": "password",
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": _vm.i.placeholder
    },
    on: {
      "change": function(v) {
        if (_vm.i.OnChange) {
          _vm.i.OnChange(v)
        }
      }
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, [(_vm.i.SuffixText) ? _c('i', {
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v(_vm._s(_vm.i.SuffixText))]) : _vm._e(), _vm._v(" "), (_vm.i.PrependText) ? _c('i', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.i.PrependText))]) : _vm._e(), _vm._v(" "), (_vm.i.AppendText) ? _c('i', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.i.AppendText))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Boolean') ? [_c('el-radio-group', {
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, _vm._l((_vm.$store.state['IsAndNot']), function(item) {
    return _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Select') ? [_c('el-select', {
    attrs: {
      "popper-append-to-body": false,
      "disabled": !!_vm.i.IsNotEdit,
      "multiple": !!_vm.i.IsMultiple,
      "clearable": !_vm.i.IsNotClearable,
      "filterable": !_vm.i.IsNotFilterable,
      "placeholder": _vm.i.placeholder
    },
    on: {
      "change": function(v) {
        if (_vm.i.OnChange) {
          var SelectItemData = new _vm.window.$LQ(_vm.$store.state[_vm.i.forSelectStoreName]).First(function(e) {
            return e.Value == v
          })
          _vm.i.OnChange(v, SelectItemData, _vm.entity, _vm.i)

        }
      }
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, [_vm._l((_vm.i.SelectSetting), function(item) {
    return (_vm.i.SelectSetting) ? _c('el-option', {
      attrs: {
        "value": item.Value,
        "label": item.Text
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(item) {
    return (!_vm.i.SelectSetting) ? _c('el-option', {
      attrs: {
        "value": item.Value,
        "label": item.Text
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'DateTime') ? [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions1,
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'monthTime') ? [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": "选择年月",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'DateTimePicker') ? [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions1,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'TimePicker') ? [_c('el-time-picker', {
    attrs: {
      "disabled": !!_vm.i.IsNotEdit,
      "placeholder": "任意时间点"
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Radio') ? [_c('el-radio-group', {
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(item) {
    return _c('el-radio', {
      staticClass: "radio",
      attrs: {
        "disabled": !!_vm.i.IsNotEdit,
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Checkbox') ? [_c('el-checkbox-group', {
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "disabled": !!_vm.i.IsNotEdit,
        "label": item.Value
      }
    }, [_vm._v(_vm._s(item.Text))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Textarea') ? [_c('el-input', {
    ref: "input",
    attrs: {
      "disabled": !!_vm.i.IsNotEdit,
      "type": "textarea",
      "autosize": {
        minRows: _vm.i.minRows ? _vm.i.minRows : 2,
        maxRows: _vm.i.maxRows ? _vm.i.maxRows : 5
      },
      "placeholder": _vm.i.placeholder
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'FunZTreeSelect') ? [(_vm.$store.state[_vm.i.forSelectStoreName]) ? _c('el-cascader', {
    staticClass: "ivu-cascader ivu-cascader-show-clear",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "placeholder": _vm.i.placeholder,
      "disabled": !!_vm.i.IsNotEdit,
      "options": _vm.$store.state[_vm.i.forSelectStoreName],
      "change-on-select": ""
    },
    model: {
      value: (_vm.i[_vm.i.forValueStoreName]),
      callback: function($$v) {
        _vm.$set(_vm.i, _vm.i.forValueStoreName, $$v)
      },
      expression: "i[i.forValueStoreName]"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'CheckboxList') ? [_c('el-checkbox-group', {
    model: {
      value: (_vm.i[_vm.i.forValueStoreName]),
      callback: function($$v) {
        _vm.$set(_vm.i, _vm.i.forValueStoreName, $$v)
      },
      expression: "i[i.forValueStoreName]"
    }
  }, _vm._l((_vm.$store.state[_vm.i.forSelectStoreName]), function(o) {
    return _c('el-checkbox', {
      attrs: {
        "label": o.Value,
        "disabled": !!_vm.i.IsNotEdit
      }
    }, [_c('span', [_vm._v(_vm._s(o.Text))])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'UploadImage') ? [_c('div', {
    staticClass: "el-form-group"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "id": _vm.i.field + '_UploadImage' + _vm.i.UploadRID
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.i.buttonName))])])]), _vm._v(" "), (_vm.entity[_vm.i.field]) ? _c('img', {
    class: _vm.i.class,
    attrs: {
      "src": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + _vm.entity[_vm.i.field]
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'UploadFile') ? [_c('div', {
    staticClass: "el-form-group"
  }, [(!_vm.i.isNotShowButton) ? _c('div', {}, [_c('div', {
    attrs: {
      "id": _vm.i.field.replace('.', '_').replace('.', '_').replace('.', '_') + '_UploadFile' + _vm.i.UploadRID
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.i.buttonName ? _vm.i.buttonName : _vm.g("$上传")))])])]) : _vm._e(), _vm._v(" "), (_vm.entity[_vm.i.field]) ? _c('a', {
    class: _vm.i.class,
    attrs: {
      "target": "_blank",
      "href": (_vm.Urlpath == '/' ? '' : _vm.Urlpath) + _vm.entity[_vm.i.field]
    }
  }, [_vm._v(_vm._s(_vm.g('$点击下载')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Editor') ? [_c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i.error))]), _vm._v(" "), _c('quill-editor', {
    staticClass: "quill-editor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.i.type == 'TagList') ? [_vm._l((_vm.entity[_vm.i.field]), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": !_vm.i.hideNew,
        "disable-transitions": false
      },
      on: {
        "close": function() {
          if (_vm.i.OnRemove) {
            _vm.i.OnRemove(tag)
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.getDataForPath(tag, _vm.i.tagField)) + "\n    ")])
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "600",
      "trigger": "hover"
    }
  }, [_c('popover-item', {
    attrs: {
      "config": _vm.i.popperConfig
    }
  }), _vm._v(" "), (!_vm.i.hideNew) ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    on: {
      "click": function() {
        if (_vm.i.OnRemove) {
          _vm.i.OnNewClick()
        }
      }
    },
    slot: "reference"
  }, [_vm._v("+ New")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'LabelSetting') ? [(!_vm.i.hideNew) ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    on: {
      "click": function() {
        _vm.$router.push('/LabelSetting')
        if (_vm.window.rootVue.thisWindow) {
          _vm.window.rootVue.thisWindow.LabelSetting_Key = _vm.i.fieldsKey;
          _vm.window.rootVue.thisWindow.LabelSetting = _vm.entity[_vm.i.field];
          _vm.window.rootVue.thisWindow.OnLabelSettingChange = function(LabelSetting) {
            _vm.$set(_vm.entity, _vm.i.field, LabelSetting)
            _vm.window.rootVue.thisWindow.LabelSetting = LabelSetting;
          }
        }

      }
    },
    slot: "reference"
  }, [_vm._v("\n        " + _vm._s(_vm.g("$查看&设置")))]) : _vm._e(), _vm._v(" "), (!_vm.i.hideNew) ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "slot": "reference",
      "size": "small"
    },
    on: {
      "click": function() {
        _vm.$set(_vm.i, 'IsShowLabelSettingData', !_vm.i.IsShowLabelSettingData)
      }
    },
    slot: "reference"
  }, [_vm._v("\n        " + _vm._s(_vm.g("$显示/隐藏数据")))]) : _vm._e(), _vm._v(" "), (_vm.i.IsShowLabelSettingData) ? _c('el-input', {
    ref: "input",
    attrs: {
      "disabled": !!_vm.i.IsNotEdit,
      "type": "textarea",
      "autosize": {
        minRows: _vm.i.minRows ? _vm.i.minRows : 2,
        maxRows: _vm.i.maxRows ? _vm.i.maxRows : 5
      },
      "placeholder": _vm.i.placeholder
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'SelectLabel') ? [_vm._v("\n     " + _vm._s(_vm._f("toSelect")(_vm.getDataForPath(_vm.entity, _vm.i.field), _vm.i.forSelectStoreName)) + "\n     "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'AddString') ? [_c('span', [_vm._v(_vm._s(_vm.i.AddString(_vm.entity)))]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'AddStringAndButton') ? [_c('span', [_vm._v(_vm._s(_vm.i.AddString(_vm.entity)) + "  "), _c('el-button', {
    style: ({
      marginRight: '5px'
    }),
    attrs: {
      "type": 'primary',
      "size": "mini"
    },
    on: {
      "click": function(v) {
        if (_vm.i.OnClick) {
          _vm.i.OnClick(v)
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.gets('$选择')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'AddHtml') ? [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.i.AddHtml(_vm.entity))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Component') ? [_c('keep-alive', [_c(_vm.i.Component, {
    tag: "component",
    attrs: {
      "entity": _vm.entity,
      "fieldconfig": _vm.field,
      "field": _vm.i
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.i.type == 'Button') ? [_c('el-button', {
    style: ({
      marginRight: '5px'
    }),
    attrs: {
      "type": _vm.i.buttonType,
      "size": "mini"
    },
    on: {
      "click": function() {
        if (_vm.i.OnClick) {
          _vm.i.OnClick(_vm.entity, _vm.field)
        }

      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i.ButtonName))]), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'ColorPicker') ? [_c('el-color-picker', {
    attrs: {
      "disabled": !!_vm.i.IsNotEdit
    },
    model: {
      value: (_vm.entity[_vm.i.field]),
      callback: function($$v) {
        _vm.$set(_vm.entity, _vm.i.field, $$v)
      },
      expression: "entity[i.field]"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e(), _vm._v(" "), (_vm.i.type == 'UE') ? [_c('UE', {
    attrs: {
      "defaultMsg": _vm.entity[_vm.i.field],
      "UE": _vm.i.UE,
      "contentChange": function(content) {
        _vm.$set(_vm.entity, _vm.i.field, content)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bs-example bs-example-bg-classes",
    class: {
      show: _vm.i.isCheck
    },
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.i.error))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf05676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/form_list_item.vue
// module id = 1273
// module chunks = 169